import type { Recipe, RecipeUUID } from '@library/menu-service'

import type { MenuRecipesState } from 'reducers/menu-recipes/recipes'

export const getAvailableRecipes = ({
  recipesV3,
}: MenuRecipesState): Record<RecipeUUID, Recipe> => {
  const { recipes } = recipesV3

  return Object.fromEntries(
    Object.values(recipes)
      .filter((recipe) => recipe.isAvailable)
      .map((recipe) => [recipe.id, recipe]),
  )
}
